var edit = "https://shopfront-cdn.tekoapis.com/static/849013b6dba79f68.svg";

export { edit as default };
